import { h, Component, JSX } from "preact";
import "./library.scss";
import { DisplayWork } from "./library";
import "./work.scss";
import Api from "../../api";
import { RefreshCw } from "preact-feather"
import Navigation, { Pages } from "../../navigation";
import NewBadge from "./NewBadge.svg";
import FinishedBadge from "./FinishedBadge.svg";
import TouchCTL from "../touch";


export interface WorkProps { work: DisplayWork, id: string }
interface WorkState { }
export class WorkComponent extends Component<WorkProps, WorkState> {
   componentDidMount() { }


   render(props: WorkProps, state: WorkState) {
      let work = props.work;
      let badge: JSX.Element;
      if (props.work.new) {
         badge = <img src={NewBadge} alt="is new" style="position: absolute; top: 0; bottom: 0; height:25%" />;
      } else if (props.work.finished) {
         badge = <img src={FinishedBadge} alt="is finished" style="position: absolute; top: 0; bottom: 0; height:25%" />
      }
      let reload: JSX.Element;
      if (props.work.reload) {
         reload = <a href="#" class="work-reload-button" aria-label={"reload work " + props.work.title + " by " + props.work.author} onClick={async evt => {
            evt.stopPropagation()
            evt.preventDefault()

            if (work && (work.type === "ao3" || work.type === "wattpad")) {
               // if (e.parentElement)
               // e.parentElement.classList.add("book-card-disabled");
               // this.disabled_works.push(id);
               await Api.addWorkWithId(work.type, work.workid);
               // this.disabled_works = this.disabled_works.filter(e => e !== id);
            }
         }}>
            <RefreshCw />
         </a>
      }

      let cover = !work.cover ? undefined : <img style="position: absolute; top: 0; bottom: 0; height: 100%; width: 100%" src={work.cover} alt="image cover" />;
      return <TouchCTL
         click={() => Navigation.setPage(Pages.Reader, work._id)}
         longclick={() => Navigation.setPage(Pages.Details, work._id)}
         context={() => Navigation.setPage(Pages.Details, work._id)}
      >
         <div class={"work-container" + (work.disabled ? " work-disabled" : "")}>
            <div class="work-image elv-8">
               {cover}
               {badge}
               {reload}
               {work.progress && work.progress > 0 ?
                  <a class="work-progress">{Math.round((work.progress * 100))}%</a>
                  : undefined
               }
            </div>
            <div class="">
               <div class="work-title">
                  <b>{work.title}</b>
               </div>
               <div class="work-subtitle">
                  {work.author}
               </div>
            </div>
         </div>
      </TouchCTL >
   }
}